import TextField from 'monday-ui-react-core/dist/TextField';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import billingInputTypes from './billing-input-types';

const types = {
  [billingInputTypes.text]: { component: TextField, props: { debounceRate: 1000, defaultValue: '' } },
  [billingInputTypes.select]: { component: Dropdown },
  [billingInputTypes.boardSelect]: { component: Dropdown, props: { placeholder: 'Choose column' } },
  [billingInputTypes.date]: {
    component: TextField,
    props: { type: 'date' },
  },
  [billingInputTypes.number]: {
    component: TextField,
    props: { type: 'number', debounceRate: 1000 },
  },
};

export default types;
